import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { addCrudCases } from '../../store/addCrudCases';
import { callThunks } from './callThunks';
import type { CallState } from './callTypes';

const initialState: CallState = {
  items: [],
  byId: {},
  currentItem: null,
  status: 'idle',
  error: null,
  filters: {},
  totalCount: 0,
};

export const callSlice = createSlice({
  name: 'calls',
  initialState,
  reducers: {
    setCallFilters(state, action: PayloadAction<Partial<CallState['filters']>>) {
      state.filters = { ...state.filters, ...action.payload };
    },
    clearCallFilters(state) {
      state.filters = {};
    },
  },
  extraReducers: (builder) => {
    addCrudCases(builder, callThunks, (c) => c.callId);
  },
});

export const { setCallFilters, clearCallFilters } = callSlice.actions;
export const callReducer = callSlice.reducer;
